
import $cookie from '~/utils/storage/cookie.js'
export default {
  name: 'cookies-accept',
  data() {
    return {
      isView: !1,
      storageName: 'cookie:accepted'
    }
  },
  props: {
    theme: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  computed: {
    site() {
      return site
    }
  },
  mounted() {
    this.isView = !this.isAccepted()
  },
  methods: {
    isAccepted() {
      let accepted = !1
      accepted = $cookie.get(this.storageName)
      return accepted
    },
    accept() {
      $cookie.set(this.storageName, !0)
      this.isView = !1
    }
  }
}
